import * as tslib_1 from "tslib";
import getOAuth2RefreshTokenInfoOperation from 'owa-service/lib/operation/getOAuth2RefreshTokenInfoOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export function getRefreshToken(authorizationCode) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var uri, request, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    uri = window.location.protocol + "//" + window.location.hostname + "/mail/GetAuthorizationCode.html";
                    request = {
                        Header: getJsonRequestHeader(),
                        OAuthProvider: 4 /* Google */,
                        RedirectUri: uri,
                        AuthorizationCode: authorizationCode,
                    };
                    return [4 /*yield*/, getOAuth2RefreshTokenInfoOperation(request)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
//# sourceMappingURL=getRefreshToken.js.map